import React from 'react'
import './Career.css'
import Banner from './banner/Banner'
import Career_Container from './career_container/Career_Container'

const Career = () => {
  return (
    <section className='Career'>
      <Banner/>
      <Career_Container/>
    </section>
  )
}

export default Career
